// extracted by mini-css-extract-plugin
export default {"container":"detailsPage_container__kIXcy","item":"detailsPage_item__jCAN+","name":"detailsPage_name__prUpt","value":"detailsPage_value__CJDbn"};